// Index file for web

import { AppRegistry } from 'react-native';
import App from './App';
import './index.css';
global.__DEV__ = process.env.NODE_ENV === 'development';
AppRegistry.registerComponent('Healthread', () => App);

AppRegistry.runApplication('Healthread', {
  rootTag: document.getElementById('root'),
});
